import { SET_BASE_PATH } from './Navigation.action';

type TNavigationState = {
    basePath: string;
};

const initialState: TNavigationState = {
    basePath: '/account/signup'
};

export default function (state = initialState, action: any) {
    switch (action.type) {
        case SET_BASE_PATH:
            return {
                ...state,
                basePath: action.payload.basePath
            };
        default:
            return state;
    }
}
